import React from 'react';
// Type defintitions
import * as TYPES from '../../types';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

var Heading = function Heading(_ref) {
  var field = _ref.field,
      level = _ref.level,
      className = _ref.className;
  var Level = level || 2;
  var Tag = "h".concat(Level);
  return /*#__PURE__*/React.createElement(RichText, {
    field: field,
    tag: Tag,
    "aria-level": Level,
    className: className
  });
};

Heading.defaultProps = {
  level: 2
};
export default Heading;